var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex justify-content-between border-bottom" }, [
      _c(
        "div",
        { staticClass: "flex-grow-1" },
        [
          _c("newsfeed-owner-info", {
            attrs: {
              user_data: _vm.data.module.owner,
              supplier_data: _vm.data.supplier,
              shared: false,
              type: _vm.data.type,
              time: _vm.data.published_at,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group mt-05 mr-05" }, [
        _c("div", { staticClass: "dropdown" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-menu",
              attrs: { "aria-labelledby": "dropdownMenuButton200" },
            },
            [
              _vm.isServiceAdmin === true ||
              _vm.user_id === _vm.data.module.owner.id ||
              _vm.isAdmin === true
                ? _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: {
                          href:
                            "/member/" +
                            this.data.module.type +
                            "/" +
                            _vm.data.module.slug +
                            "/edit",
                        },
                      },
                      [
                        _c("i", { staticClass: "feather icon-settings" }),
                        _vm._v(_vm._s(_vm.__("globals.edit_post"))),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isServiceAdmin === true ||
              _vm.user_id === _vm.data.module.owner.id ||
              _vm.isAdmin === true
                ? _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.destroy.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "feather icon-trash-2" }),
                        _vm._v(_vm._s(_vm.__("globals.delete_post"))),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item danger",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.report.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "feather icon-alert-triangle" }),
                  _vm._v(_vm._s(_vm.__("globals.report_post"))),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.data.module.cover !== null
      ? _c("div", { staticClass: "shadow" }, [
          _c("img", {
            staticClass: "img-fluid",
            staticStyle: { "object-fit": "cover" },
            attrs: { src: _vm.data.module.cover.url },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-content pt-1 pb-1" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "w-100" }, [
            _vm.data.module.cover === null
              ? _c("div", [
                  _vm.data.module.resource_file_type === "doc"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/doc.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "docx"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/doc.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "txt"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/doc.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "pdf"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/pdf.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "xls"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/xls.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "xlsx"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/xls.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "ppt"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/ppt.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "pptx"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/ppt.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.module.resource_file_type === "lms"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/lms.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "h3" }, [
              _c(
                "a",
                {
                  staticStyle: { color: "inherit" },
                  attrs: {
                    href:
                      "/member/" +
                      this.data.module.type +
                      "/" +
                      _vm.data.module.slug,
                  },
                },
                [_vm._v(_vm._s(_vm.data.module.title))]
              ),
            ]),
            _vm._v(" "),
            _vm.rating !== null && _vm.rating !== 0
              ? _c("div", { staticClass: "mt-05  mb-05" }, [
                  _c("span", {
                    class: "rating-static rating-" + _vm.rating * 10,
                  }),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pt-05 pb-05" }, [
          _vm.collapse_body
            ? _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                staticClass: "breakAll image-resize ",
                domProps: {
                  innerHTML: _vm._s(_vm.data.module.resource_description),
                },
              })
            : _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                ref: "textBox",
                class: _vm.class_body + " image-resize ",
                domProps: {
                  innerHTML: _vm._s(_vm.data.module.resource_description),
                },
              }),
          _vm._v(" "),
          _vm.enable_read_more
            ? _c("div", [
                _vm.collapse_body
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-link font-small-3 mt-05 mb-05 p-0",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.collapse_body = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.__("globals.read_less")) +
                            " "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-up" }),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-link font-small-3 mt-05 mb-05 p-0",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.collapse_body = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.__("globals.read_more")) +
                            " "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" }),
                      ]
                    ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.data.module.can_be_downloaded === false &&
          _vm.data.module.price > 0
            ? _c("div", { staticClass: "pb-1 pt-05 text-bold-700" }, [
                _c("span", { staticClass: "font-small-2 pt-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.__("globals.form.paragraph.your_price")) +
                      " " +
                      _vm._s(
                        _vm._f("currency")(_vm.data.module.price, _vm.site_tax)
                      ) +
                      " " +
                      _vm._s(_vm.__("globals.all_inclusive"))
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.user.confirmed
        ? _c("div", { staticClass: "border-top" }, [
            _c("div", { staticClass: "pl-1 pr-1 pt-05" }, [
              _vm.data.module.price === null &&
              this.lowest_plan_price !== null &&
              _vm.data.module.can_be_downloaded === false
                ? _c("span", { staticClass: "font-small-2" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("currency")(
                            this.lowest_plan_price,
                            _vm.site_tax
                          )
                        ) +
                        " " +
                        _vm._s(_vm.__("globals.for")) +
                        " " +
                        _vm._s(this.lowest_plan_name) +
                        " " +
                        _vm._s(_vm.__("plan.upgrade_plan_message")) +
                        "\n                    "
                    ),
                  ])
                : _vm.data.module.can_be_downloaded &&
                  _vm.data.module.resource_file_type !== "lms"
                ? _c("span", { staticClass: "border-bottom" }, [
                    _vm.data.module.external_url !== null
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "download-button btn btn-primary waves-effect waves-light form-control",
                              attrs: {
                                href:
                                  "/member/" +
                                  this.data.module.type +
                                  "/" +
                                  _vm.data.module.slug +
                                  "/access-external-link",
                                target: "_blank",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-link" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.__(
                                      "resource.form.buttons.access_external_resource"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ])
                      : _c("div", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "download-button btn btn-primary waves-effect waves-light form-control",
                              attrs: {
                                href:
                                  "/member/" +
                                  this.data.module.type +
                                  "/" +
                                  _vm.data.module.slug +
                                  "/download-file",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-download" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.__("resource.form.buttons.download")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]),
                  ])
                : _vm.data.module.price > 0 &&
                  _vm.data.module.can_be_downloaded === false
                ? _c("span", { staticClass: "border-bottom" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "download-button btn btn-primary waves-effect waves-light form-control",
                        attrs: {
                          href:
                            "/member/" +
                            this.data.module.type +
                            "/" +
                            _vm.data.module.slug +
                            "/add_to_cart",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-download" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.__("resource.form.buttons.buy")) +
                            " "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "p-2",
        staticStyle: { display: "none" },
        attrs: { id: "progress" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-sm btn-outline-light dropdown-toggle ",
        staticStyle: { border: "none" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-chevron-circle-down mr-0" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }